import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import Facade from "@/Facade";
import ScaleManager from "../stage/ScaleManager";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import {Signals} from "@/Imports";
import SpineRepeatedAnimation from "@base/spineAnimation/SpineRepeatedAnimation";

export default class RewardContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {

    this.bonusData = [
      {
        1.05:"tealBonus5",
        1.1:"tealBonus10",
        1.2:"tealBonus20"
      },
      {
        1.2:"purpuleBonus20",
        1.3:"purpuleBonus30",
        1.4:"purpuleBonus40"
      },
      {
        1.2:"yellowBonus20",
        1.4:"yellowBonus40",
        2:"yellowBonus100"
      }
    ]

    this.bonusIndex = 0
    Signals.stopFeature.add(this.onStopFeature, this)
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.showfreebets.add(this.onShowfreebets, this)

    this.messages = new SpineRepeatedAnimation('rewardMessages', null, this.onComplete.bind(this))
    this.addChild(this.messages)
    // M.Novko: IDK why it's need to be invoked immediately
    // this.messages.start(['freeBet'], [true])
    this.visible = false
  }

  onShowfreebets(value) {
    if(value == 0) {
      return
    }

    this.visible = true
    this.messages.start(['freeBet'], [5])
    Facade.soundManager.play('space_boss_win_freebet', 0.1, false, 'default')

  }

  onStopFeature(currentBonus) {
    if (!currentBonus) {
      return
    }
    if(currentBonus.tp === "multiplier" && currentBonus.v > 1) {
      this.visible = true
      this.bonusIndex = this.checkBonusIndex(currentBonus.pos)

      const name = this.bonusData[this.bonusIndex][currentBonus.v]
      if (name)
        this.messages.start([name], [6])
      Facade.soundManager.play('space_boss_win_bonus', 0.1, false, 'default')
    }
  }

  checkBonusIndex(multiplier) {
    if(multiplier >= 5 && multiplier <= 8) return 0
    if(multiplier >= 25 && multiplier <= 40) return 1
    if(multiplier >= 80 && multiplier <= 120) return 2
  }

  onMakeBets() {
    this.bonusIndex = 0
  }

  onComplete() {
    this.visible = false
  }
}
